import { render, staticRenderFns } from "./RootLayout.vue?vue&type=template&id=3cca3f14&scoped=true"
import script from "./RootLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./RootLayout.vue?vue&type=script&setup=true&lang=js"
import style0 from "./RootLayout.vue?vue&type=style&index=0&id=3cca3f14&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cca3f14",
  null
  
)

export default component.exports